'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _propTypes = require('prop-types');

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _EntityMapper = require('./EntityMapper');

var _EntityMapper2 = _interopRequireDefault(_EntityMapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntityListMapper = function EntityListMapper(_ref) {
    var mapper = _ref.mapper,
        entities = _ref.entities,
        entityWrapper = _ref.entityWrapper,
        entityProps = _ref.entityProps,
        asyncMapper = _ref.asyncMapper;
    return entities.map(function (ref, index) {
        var EntityWrapper = entityWrapper || React.Fragment;
        var uuid = isEntityReferenceField(ref) ? ref.target_uuid : ref;
        return React.createElement(EntityWrapper, { key: uuid }, React.createElement(_EntityMapper2.default, { uuid: uuid, mapper: mapper, asyncMapper: asyncMapper, entityProps: (0, _assign2.default)({}, entityProps, { index: index }) }));
    });
};
function isEntityReferenceField(field) {
    return (typeof field === 'undefined' ? 'undefined' : (0, _typeof3.default)(field)) === 'object' && typeof field.target_uuid === 'string';
}
EntityListMapper.propTypes = {
    asyncMapper: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])]),
    entities: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
        target_uuid: PropTypes.string.isRequired
    }), PropTypes.string])).isRequired,
    entityProps: PropTypes.shape({}),
    entityWrapper: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    mapper: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])
};
EntityListMapper.defaultProps = {
    asyncMapper: undefined,
    entityProps: undefined,
    entityWrapper: undefined,
    mapper: undefined
};
exports.default = EntityListMapper;
//# sourceMappingURL=EntityListMapper.js.map
